Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS,
    spacing = _STYLES$useStyles.spacing,
    bp = _STYLES$useStyles.bp,
    fontBold = _STYLES$useStyles.fontBold,
    fontSemiBold = _STYLES$useStyles.fontSemiBold;
  var title = {
    textAlign: 'center'
  };
  var textContainer = {
    textAlign: 'center'
  };
  var legend = Object.assign({}, fontBold, {
    color: COLORS.aubergine
  });
  var list = {
    width: '100%',
    alignItems: 'center',
    marginBottom: spacing.xxxl
  };
  var stepCard = {
    flexGrow: 1,
    maxWidth: _styles.STYLES.grid.maxBoxWidth
  };
  var cardActions = {
    marginTop: spacing.m
  };
  var linkText = {
    textAlign: 'center',
    fontSize: _styles.STYLES.fontSize.normal,
    lineHeight: _styles.STYLES.lineHeight.normal
  };
  var stepCardDescriptionContainer = {
    marginBottom: spacing.m
  };
  var stepCardDescription = {
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s
  };
  if (bp.is([bp.tablet, bp.desktop])) {
    stepCardDescription.fontSize = _styles.STYLES.fontSize.normal;
    stepCardDescription.lineHeight = _styles.STYLES.lineHeight.normal;
  }
  var bulletListHeading = {
    fontSize: _styles.STYLES.fontSize.m,
    lineHeight: _styles.STYLES.lineHeight.m
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
    bulletListHeading.fontSize = _styles.STYLES.fontSize.normal;
    bulletListHeading.lineHeight = _styles.STYLES.lineHeight.normal;
    bulletListHeading.textAlign = 'center';
  }
  var bulletListText = {
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s
  };
  if (bp.is([bp.tablet, bp.desktop])) {
    bulletListText.fontSize = _styles.STYLES.fontSize.normal;
    bulletListText.lineHeight = _styles.STYLES.lineHeight.normal;
  }
  var messageTextContainer = {
    textAlign: 'center',
    marginBottom: spacing.l,
    maxWidth: _styles.STYLES.grid.maxBoxWidth
  };
  var messageText = Object.assign({}, fontSemiBold, {
    fontSize: _styles.STYLES.fontSize.m,
    lineHeight: _styles.STYLES.lineHeight.m,
    color: COLORS.aubergine
  });
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
    messageText.fontSize = _styles.STYLES.fontSize.normal;
    messageText.lineHeight = _styles.STYLES.lineHeight.normal;
  }
  var messageCTAContainer = {
    marginBottom: spacing.l
  };
  var styles = _reactNative.StyleSheet.create({
    title: title,
    textContainer: textContainer,
    legend: legend,
    list: list,
    stepCard: stepCard,
    cardActions: cardActions,
    linkText: linkText,
    stepCardDescriptionContainer: stepCardDescriptionContainer,
    stepCardDescription: stepCardDescription,
    bulletListHeading: bulletListHeading,
    bulletListText: bulletListText,
    messageTextContainer: messageTextContainer,
    messageText: messageText,
    messageCTAContainer: messageCTAContainer
  });
  return {
    styles: styles
  };
};